const ValidateFile = (files, allowedFormats) => {
    // Handle both FileList (from register) and single File (from Controller)
    const file = files instanceof FileList ? files[0] : files;
    if (!file) return true;
    console.log("Detected File Type:", file.type);
    const size = file.size;
    //const minSize = 10 * 1024;
    const maxSize = 10 * 1024 * 1024;

    const formatsArray = Array.isArray(allowedFormats) ? allowedFormats : [allowedFormats];

    if (!formatsArray.includes(file?.type)) {
        const friendlyNames = formatsArray.map(type => type.split('/')[1].toLowerCase()).join(', ');
        return `Invalid format. Only ${friendlyNames} are allowed.`;
    }

    //if (size < minSize) return "File is too small (Minimum 10KB required)";
    if (size > maxSize) return "File is too large (Maximum 10MB allowed)";
    return true;
}

export default ValidateFile;